import { useMemo } from 'react';
import { useConfiguration } from '@/contexts/ConfigurationContext';

export type PaymentMethod = 'card' | 'sepa' | 'multibanco' | 'mb_way' | 'bacs';

export type PaymentMethodAvailability = {
  card: boolean;
  sepa: boolean;
  multibanco: boolean;
  mb_way: boolean;
  bacs: boolean;
};

/**
 * Hook to check payment method availability from journey config.
 *
 * The compiled config (journey domain, payment_settings) is the single
 * authority for which payment methods are shown in the customer portal.
 * Hub operators control visibility via toggles, with validation that
 * a backing provider exists before a method can be enabled.
 *
 * @returns Object with availability status for each payment method and loading state
 */
export function usePaymentMethodAvailability() {
  const { config, isLoading } = useConfiguration();

  const providers = config.payment.providers;
  const data = useMemo<PaymentMethodAvailability>(
    () => ({
      card: providers?.card?.enabled ?? false,
      sepa: providers?.sepa?.enabled ?? false,
      multibanco: providers?.multibanco?.enabled ?? false,
      mb_way: providers?.mb_way?.enabled ?? false,
      bacs: providers?.bacs?.enabled ?? false,
    }),
    [providers],
  );

  return {
    data,
    isLoading,
  };
}
